import { db, storage, functions } from '@/firebase'

export default {
  saveCompatibilidadCarta({ rootState }, carta) {
    let negocioGest = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocioGest)
      .set({
        carta: carta
      }, { merge: true })
  },
  saveCartaRest({ rootState }, { carta, file }) {
    let restauranteGest = rootState.app.restauranteGest;
    let negocioGest = rootState.app.negocioGest;
    if (file) {
      var storageRef = storage.ref();
      var ref = storageRef.child('negocios/' + negocioGest + '/carta/' + restauranteGest + '.pdf');
      return ref.put(file)
        .then((r) => {
          return r.ref.getDownloadURL()
        })
        .then((url) => {
          carta.pdf = url;
          return db.collection('restaurantes').doc(restauranteGest)
            .set({
              carta: carta
            }, { merge: true })
        })
    } else {
      //carta.pdf = null;
      return db.collection('restaurantes').doc(restauranteGest)
        .set({
          carta: carta
        }, { merge: true })
    }
  }
}